export default {
	colors: {
		ColorBigStone: '#15233B',
		ColorApricot: '#F59C00',
		ColorWhite: '#ffffff',
		ColorPearl: '#F8F8F8',
		ColorMediumGray: '#7B7F86',
		ColorYellowTan: '#FFE173',
		ColorBrightGray: '#EAEAEA',
		ColorBrightMaroon: '#C8264C',
		ColorSeeGreen: '#318D51',
		ColorCobalt: '#17428A',
		ColorWineBerry: '#5C293C',
		ColorGreenPea: '#1E5F4B',
		ColorMalibu: '#6EC8F0',
		ColorBlackPearl: '#0D1522',
		ColorPurpleHaze: '#413278',
		ColorCowBoy: '#6E3C37',
		ColorLayer: 'linear-gradient(0, #14233c00 0%, #080e1766 100%)',
		ColorBegonia: '#FF6E73',
		transparent: 'transparent',
	},

	mediaQuery: {
		DesktopSizeXL: '2560px',
		DesktopSizeL: '1920px',
		DesktopSizeM: '1510px',
		DesktopSizeS: '1440px',
		DesktopSizeXS: '1280px',
		TabletSize: '1024px',
		TabletSizeS: '768px',
		MobileSize: '601px',

		DesktopSizeXLMin: '2559px',
		DesktopSizeLMin: '1919px',
		DesktopSizeMMin: '1509px',
		DesktopSizeSMin: '1439px',
		DesktopSizeXSMin: '1279px',
		TabletSizeMin: '1023px',
		TabletSizeSMin: '767px',
		MobileSizeMin: '600px',
	},
};
